import { ReactNode } from "react";
import { create } from "zustand";

type AppBarThemeConfig = {
  show?: boolean;
  fixed?: boolean;
  title?: string;
  checkout?: boolean;
  shopList?: boolean;
  leading?: "home" | "back";
  actions?: [ReactNode?, ReactNode?, ReactNode?];
};

type HeaderThemeConfig = {
  buttonBack?: boolean;
  title?: ReactNode;
  filter?: boolean;
  image?: boolean;
  // buttonLogout?: boolean;
  // type?: "large" | "small";
};

interface ThemeStore {
  appBar: AppBarThemeConfig;
  header: HeaderThemeConfig;
  bottomNavigation: "hidden" | "home" | "marketplace";
  popupStatus: boolean;
  setAppBar(config: AppBarThemeConfig): void;
  setHeader(config: HeaderThemeConfig): void;
  setBottomNavigation(status: "hidden" | "home" | "marketplace"): void;
  setPopupStatus: (popupStatus: boolean) => void;
}

export const useThemeStore = create<ThemeStore>((set) => ({
  appBar: {
    show: true,
    fixed: false,
    checkout: false,
    shopList: false,
    title: "",
    leading: "home",
    actions: [],
  },
  header: {
    buttonBack: false,
    title: null,
    filter: true,
    image: true,
    // type: "large",
  },
  popupStatus: false,
  bottomNavigation: "hidden",
  subMenu: "payment",
  setAppBar: (config: AppBarThemeConfig) =>
    set((state) => ({ appBar: { ...state.appBar, ...config } })),
  setHeader: (config: HeaderThemeConfig) =>
    set((state) => ({ header: { ...state.header, ...config } })),
  setBottomNavigation: (status: "hidden" | "home" | "marketplace") =>
    set({ bottomNavigation: status }),
  setPopupStatus: (popupStatus) => set({ popupStatus }),
}));
